$(document).ready(function() {
    $('.custom_cat .collection-list').owlCarousel({
        loop: false,
        margin: 20,
        nav: true,
        responsive: {
            0: {
                items: 2
            },
            600: {
                items: 3
            },
            1000: {
                items: 5
            }
        }
    });
});



$('.custom_slider_test').owlCarousel({
    loop: true, // Slider repeat hoga
    margin: 0,
    nav: true,
    autoplay: true, // Auto slide
    autoplayTimeout: 3000, // Kitne milliseconds ke baad slide change hoga
    autoplayHoverPause: true, // Hover par autoplay pause hoga
    responsive: {
        0: {
            items: 1
        },
        600: {
            items: 1
        },
        1000: {
            items: 1
        }
    }
});



$(document).ready(function(){
  if ($('.banner img').length > 0) {
    $('.section-header__title').addClass('has-banner');
  }
});

    $(document).ready(function(){
        const maxWords = 30;
        const $content = $('.product-single__meta .collapsible-content__inner p').text();
        const words = $content.split(/\s+/);

        if (words.length > maxWords) {
            const truncatedContent = words.slice(0, maxWords).join(' ') + '...';
            $('.product-single__meta .collapsible-content__inner p').text(truncatedContent);
        }
    });

$(document).on('change', '.variant-input-wrap input[type="radio"]', function() {
    const stockCheckValue = $(this).attr('stock-check');
    $('.stock_check').val(stockCheckValue);
});



document.querySelectorAll('.site-nav__details, .mega-menu').forEach((dropdown) => {
  dropdown.addEventListener('mouseenter', () => {
    dropdown.setAttribute('open', true);
  });
  dropdown.addEventListener('mouseleave', () => {
    dropdown.removeAttribute('open');
  });
});
